import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Space, Tooltip } from 'ant-design-vue';
import SizeSetting from './size-setting.vue';
import RefreshSetting from './refresh-setting.vue';
import ColumnSetting from './column-setting.vue';
import OrderParam from "./order-param.vue"; //排序设置界面
import QueryForm from "./filter-query-form.vue" //更多条件查询界面


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  showOrderParama: {
    type: Boolean,
    default: false,
  },
  showFullScreen: {
    type: Boolean,
    default: true,
  },
  showAutoForm: {
    type: Boolean,
    default: true,
  }
},
  emits: ['clos-change-by-tools', "order-change", "full-screen", "complex-query"],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit
const handleClosChange = function (cols) {
  emits('clos-change-by-tools', cols)
}

const handleOrderChange = function (form, union) {
  emits('order-change', form, union)
}

const handleFullScreen = function (val) {
  emits('full-screen', val)
}

const handlerComplexChange = function (val) {
  //复杂查询条件
  emits('complex-query', val)

}

return (_ctx: any,_cache: any) => {
  const _component_FullscreenOutlined = _resolveComponent("FullscreenOutlined")!
  const _component_FullscreenExitOutlined = _resolveComponent("FullscreenExitOutlined")!

  return (_openBlock(), _createBlock(_unref(Space), { size: 8 }, {
    default: _withCtx(() => [
      (props.showFullScreen == false)
        ? (_openBlock(), _createBlock(_unref(Tooltip), {
            key: 0,
            placement: "top"
          }, {
            title: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('component.table.fullScreen')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_FullscreenOutlined, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleFullScreen(true)))
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_unref(Tooltip), {
            key: 1,
            placement: "top"
          }, {
            title: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('component.table.exitFullScreen')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_FullscreenExitOutlined, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleFullScreen(false)))
              })
            ]),
            _: 1
          })),
      _createVNode(RefreshSetting),
      _createVNode(ColumnSetting, { onClosChangeByTools: handleClosChange }),
      _createVNode(SizeSetting),
      (props.showOrderParama)
        ? (_openBlock(), _createBlock(OrderParam, {
            key: 2,
            onOrderConfirm: handleOrderChange
          }))
        : _createCommentVNode("", true),
      (props.showAutoForm)
        ? (_openBlock(), _createBlock(QueryForm, {
            key: 3,
            onComplexQuery: handlerComplexChange
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})